import React from "react";
import styled from "styled-components";
import { RadioGroup as RG } from "react-radio-group";
import { spacingM } from "@rhumbix/rmbx_design_system_design_tokens";
// /**
//  * A wrapper for RadioGroup in react-radio-group
//  *
//  * @param {function} onChange    The change handler for the radio group
//  * @param {name} string          The name for the radio group
//  * @param {string} arialabel     Sets a label to attach to the toggle for screen readers
//  * @param {children} any         The components inside the RadioGroup (typically labels and radio controls)
//  * @param {selectedValue} any    Optional: Selected value, if any
//  * @returns The component
//  */
export const RadioGroup = (props) => {
    return (React.createElement(StyledRadioGroup, { name: props.name, "aria-label": props.arialabel, onChange: props.onChange, selectedValue: props?.selectedValue }, props.children));
};
const StyledRadioGroup = styled(RG) `
    margin-top: ${spacingM};
`;
export default RadioGroup;
